import React, { useContext, createContext } from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { Box } from '@mui/material';
import DataContext from '../../../context/DataProvider/DataContext';
import columns from './columnDefinition';
import Table from '../../../components/Table/Table';
import EditTableRowFormDialog from './components/EditTableRowFormDialog';
import BooleanEditor from './components/BooleanEditor';
import BooleanFormatter from './services/booleanFormatter';

function BooleanTypeProvider() {
  return (
    <DataTypeProvider formatterComponent={BooleanFormatter} editorComponent={BooleanEditor} for={['is_default']} />
  );
}

const Provider = [BooleanTypeProvider];

const BranchOfficeContext = createContext<any>(null);

function AddCommand() {
  const { setSelectedRow, setOpen } = useContext(BranchOfficeContext);
  return (
    <Box>
      <IconButton
        onClick={() => {
          setSelectedRow(undefined);
          setOpen(true);
        }}
      >
        <AddIcon />
      </IconButton>
    </Box>
  );
}

function EditCommand({ row }: any) {
  const { setSelectedRow, setOpen } = useContext(BranchOfficeContext);
  return (
    <Box display="flex" width="100%" justifyContent="center">
      <IconButton
        onClick={() => {
          setSelectedRow(row);
          setOpen(true);
        }}
        title="Bearbeiten"
      >
        <EditIcon />
      </IconButton>
    </Box>
  );
}

function AllBrachofficeTable() {
  const { brachOffices } = useContext(DataContext);
  const [open, setOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState();

  const editingStateColumnExtensions = [{ columnName: 'id', editingEnabled: false }];

  const contextValue = React.useMemo(() => ({ setSelectedRow, setOpen }), [setSelectedRow, setOpen]);

  return (
    <>
      <EditTableRowFormDialog
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        rowValue={selectedRow}
      />
      <BranchOfficeContext.Provider value={contextValue}>
        <Table
          row={brachOffices}
          columns={columns}
          defaultColumnWidths={columns.map((column) => ({ columnName: column.name, width: 'auto' }))}
          columnExtensions={editingStateColumnExtensions}
          defaultHiddenColumnNames={['domain', 'show_in_export', 'logo', 'title_for_worker_passport']}
          editable
          showAddCommand
          showEditCommand
          dataTypeProvider={Provider}
          TableCommandComponents={{
            add: AddCommand,
          }}
          EditCellForCommand={EditCommand}
        />
      </BranchOfficeContext.Provider>
    </>
  );
}

export default AllBrachofficeTable;
